import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../common/common_components/pagination_holder/Pagination_Holder";
import Image_Show_Modal from "../../../../../common/common_modal/image_show_modal/image_show_modal";
import { formatDate } from "../../../../../utils/common";

const Table = ({
  setEdit,
  setCurrentPage,
  currentPage,
  externalauditdetails,
}) => {
  const data = externalauditdetails?.data || [];

  const getStatusClass = (status) => {
    switch (status) {
      case "Pending":
        return "red";
      default:
        return "";
    }
  };

  // const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = externalauditdetails?.per_page || 10;
  const totalPages = externalauditdetails?.total_pages || 1;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const [show, setShow] = useState(false);
  const [showData, setShowData] = useState("");

  const [showNc, setShowNC] = useState(false);
  const [showDataNC, setShowDataNC] = useState("");

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Date</th>
                <th>Document Name</th>
                <th>Remarks</th>
              </tr>
            </thead>

            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td colSpan="4" className="text-center">
                    No Data Available
                  </td>
                </tr>
              ) : (
                data?.map((row, index) => {
                  return (
                    <tr key={row.id}>
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td>{formatDate(row.createdAt)}</td>
                      <td>{row.name || "-"}</td>
                      <td>{row.remark || "-"}</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {(currentPage - 1) * itemsPerPage + 1} To{" "}
            {Math.min(currentPage * itemsPerPage, data.length)} Of{" "}
            {externalauditdetails?.total || 0} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>

        <Image_Show_Modal
          onHide={() => setShow(false)}
          show={show}
          showData={showData}
          imgSrc={
            process.env.REACT_APP_IMG_URL + showData?.attach_file ||
            showData?.nc_file
          }
        />

        <Image_Show_Modal
          onHide={() => setShowNC(false)}
          show={showNc}
          showData={showDataNC}
          imgSrc={process.env.REACT_APP_IMG_URL + showData?.nc_file}
        />
      </div>
    </>
  );
};

export default Table;
